export default function Dots({size = 16, color = "#D9D9D9"}) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1371_145)">
        <circle cx="2" cy="8.00049" r="1" fill={color} />
        <circle cx="8" cy="8.00049" r="1" fill={color} />
        <circle cx="14" cy="8.00049" r="1" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1371_145">
          <rect width="16" height="16" fill="white" transform="translate(0 0.000488281)" />
        </clipPath>
      </defs>
    </svg>
  );
}
